import React, { Component } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';
import './CcyList.css';

class CcyList extends Component {
  static get propTypes() {
    return {
      currencies: PropTypes.array.isRequired,
      name: PropTypes.string.isRequired,
      placeholder: PropTypes.string,
      onSelectCcy: PropTypes.func,
      value: PropTypes.string
    };
  }

  handleOnChange(selectedCcy) {
    const { onSelectCcy } = this.props;
    if (onSelectCcy !== undefined) {
      onSelectCcy(selectedCcy.value);
    }
  }

  render() {
    const { currencies, name, placeholder, value } = this.props;

    if (currencies === undefined) return null;
    return (
      <Select
        className="CcyList"
        id={name}
        name={name}
        placeholder={placeholder}
        options={currencies.map(c => ({ label: c, value: c }))}
        searchable
        value={value}
        onChange={selected => this.handleOnChange(selected)}
        clearable={false}
      />
    );
  }
}

export default CcyList;



// WEBPACK FOOTER //
// ./src/admin/currencyPairs/CcyList.js